import * as tslib_1 from "tslib";
import createPalette from './palette';
import createTypography from './typography';
import shadows from './shadows';
import transitions from './transitions';
import zIndex from './zIndex';
import spacing from './spacing';
/**
 * 创建主题
 * @param options 主题配置
 */
export default function createTheme(options) {
    if (options === void 0) { options = {}; }
    var palette = options.palette || createPalette();
    var typography = options.typography || createTypography(palette);
    return tslib_1.__assign({ shadows: shadows,
        transitions: transitions,
        zIndex: zIndex,
        spacing: spacing }, options, { palette: palette,
        typography: typography });
}
//# sourceMappingURL=theme.js.map